import component from './ct-check'

const com = {
  install (Vue) {
    Vue.component('CTcheck', component)
  }
}
export default com